import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate, fmtTime } from "@/lib/community";
import { useAdminData, adminAct, Panel, btnLine } from "./shared";

const CARDS = [
  ["members_approved", "Jenova Girls"], ["applications_pending", "Applications to review"], ["prive_approved", "Privé members"],
  ["prive_pending", "Privé verifications"], ["events_upcoming", "Upcoming experiences"], ["rsvps_confirmed", "Confirmed RSVPs"],
  ["rsvps_waitlisted", "On waitlists"], ["rsvps_30d", "RSVPs · last 30 days"], ["attended_total", "Check-ins"],
  ["announcements_published", "Bulletins published"], ["announcements_scheduled", "Bulletins scheduled"], ["photos_pending", "Photos to approve"],
  ["photos_approved", "Photos on the wall"], ["emails_sent_30d", "Emails · last 30 days"], ["unsubscribed", "Unsubscribed"],
  ["tickets_sold", "Tickets sold"], ["ticket_revenue", "Ticket revenue"],
];

export default function OverviewTab({ goTo }) {
  const [s, reload] = useAdminData("/admin/community/stats");
  const run = async () => {
    const r = await adminAct(() => api.post("/admin/community/run-scheduler"));
    if (r) {
      window.alert(`Scheduler ran: ${r.published} bulletin(s) published, ${r.reminders} reminder(s) sent.`);
      reload();
    }
  };
  if (!s) return null;
  return (
    <div className="space-y-6" data-testid="admin-community-overview">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {CARDS.map(([k, label]) => (
          <div key={k} className="bg-white border border-[#E8DCCB] rounded-lg p-5" data-testid={`stat-${k}`}>
            <p className="font-serif text-4xl">{k === "ticket_revenue" ? `$${((s.ticket_revenue_cents || 0) / 100).toLocaleString()}` : s[k]}</p>
            <p className="text-[10px] uppercase tracking-[0.18em] text-[#7A6A62] mt-2">{label}</p>
          </div>
        ))}
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <Panel title="Next experiences" action={<button className={btnLine} onClick={() => goTo("events")} data-testid="overview-manage-events">Manage</button>}>
          {s.upcoming_events.length ? (
            <ul className="divide-y divide-[#F0E8DD]">
              {s.upcoming_events.map((e) => (
                <li key={e.id} className="py-3 flex justify-between gap-3 text-sm">
                  <Link to={`/events/${e.id}`} target="_blank" className="hover:underline">{e.title}</Link>
                  <span className="text-[#7A6A62] shrink-0">{fmtDate(e.start_at, { month: "short", day: "numeric" })} {fmtTime(e.start_at)} · {e.confirmed_count}/{e.capacity}</span>
                </li>
              ))}
            </ul>
          ) : <p className="text-sm text-[#7A6A62]">No upcoming experiences.</p>}
        </Panel>
        <Panel title="Automations">
          <p className="text-sm text-[#4A403B] leading-relaxed">Every 15 minutes the platform publishes scheduled bulletins (and emails subscribers) and sends reminders to confirmed guests 24 hours before each experience.</p>
          <button onClick={run} className={`${btnLine} mt-5`} data-testid="overview-run-scheduler"><Play className="w-3.5 h-3.5" /> Run now</button>
        </Panel>
      </div>
    </div>
  );
}
